import { universityIdsWithTests } from './constants';

export function hasUniversityTest(universityId?: string | number): boolean {
  return universityIdsWithTests.has(Number(universityId));
}
